import * as prismic from '@prismicio/client';
import * as prismicNext from '@prismicio/next';
import {
    BlogPageDocumentData,
    ComparisonPageDocumentData,
} from 'prismicio-types';
import sm from '../slicemachine.config.json';
import { env } from './env.mjs';

export const repositoryName = prismic.getRepositoryName(sm.apiEndpoint);

// Update the Link Resolver to match your project's route structure
export const linkResolver: prismic.LinkResolverFunction = (doc) => {
    switch (doc.type) {
        case 'category_page':
            return `/${doc.uid}`;
        case 'blog_page':
            return `/${(doc.data as BlogPageDocumentData).parent}/${doc.uid}`;
        case 'comparison_page':
            return `/${(doc.data as ComparisonPageDocumentData).parent}/${doc.uid}`;
        case 'doctor_page':
            return `/practitioners/${doc.uid}`;
        case 'performance_page':
            return `/start/${doc.uid}`;
        case 'app_download':
            return `/app-download/${doc.uid}`;
        default:
            return `/${doc.uid}`;
    }
};

export const createClient = (config: prismic.ClientConfig = {}) => {
    const client = prismic.createClient(sm.apiEndpoint, {
        fetchOptions:
            process.env.NODE_ENV === 'production'
                ? { next: { tags: ['prismic'] }, cache: 'force-cache' }
                : { next: { revalidate: 5 } },
        ...config,
        accessToken: env.PRISMIC_ACCESS_TOKEN,
    });

    // NOTE: These don't work in Firefox!
    prismicNext.enableAutoPreviews({
        client,
    });

    return client;
};
